import { Manager } from 'socket.io-client';

const manager = new Manager('https://api.ijoby.ru', {
  path: '/ws/v1/socket.io',
  transports: ['websocket'],
  autoConnect: false,
});

export const socket = manager.socket('/chat', {});
